export default __webpack_public_path__ + "static/media/robocom1.eee71ef7.jpg";